export default function ErrorPage() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>⚠️ Something went wrong</h2>
      <p>Please try again later.</p>
    </div>
  );
}